import React from 'react';
import BrandLogo from 'assets/logo/brand/brand_black_regular.png'
import { surveyLogo } from "state/Survey/atoms"
import { useRecoilValue } from "recoil"


import 'styles/brand.scss'

const BrandBlack = () => {
  const survey_logo = useRecoilValue(surveyLogo)

  if (survey_logo) {
    return (<img src={survey_logo} className="survey_logo" alt="Logo" />)
  }

  return (
    <img src={BrandLogo} className="drivin_logo" alt="Logo" />
  )
}

export default BrandBlack